import {
  observableFetchClient,
  createAuthorizationHeaders,
} from '@vp/common-api-utils';

const TAX_ID_URL_PROD = 'https://taxidmanagement.spi.orders.vpsvc.com/taxId';
const TAX_ID_URL_DEV =
  'https://taxidmanagement-staging.spi.orders.vpsvc.com/taxId';

const getUrl = (environment) =>
  environment === 'PRODUCTION' ? TAX_ID_URL_PROD : TAX_ID_URL_DEV;

/**
 * Persists the taxId to the tax-id-service and returns the resulting taxIdReference.
 *
 * @param {string} taxId taxId to persist
 * @param {string} authToken token to use on the http request
 * @param {string} environment tax-id-service environemnt to use (STAGING or PRODUCTION)
 */
export async function persistTaxId({ taxId, authToken, environment }) {
  try {
    const response = await observableFetchClient({
      url: getUrl(environment),
      method: 'PUT',
      headers: {
        ...createAuthorizationHeaders(authToken),
      },
      body: JSON.stringify({ taxId }),
    });

    const data = await response.json();

    if (!data?.taxIdReference) {
      throw new Error('Unknown error generating a taxIdReference.');
    }

    return data.taxIdReference;
  } catch (error) {
    console.warn('[TAX-ID-UI] Failed to save tax id.', error);
    throw error;
  }
}
